import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../api/client";

async function fetchAllData() {
  const [investor] = await Promise.all([
    clientAPI("get", `/investor?page=1&limit=99999999`),
  ]);

  return {
    investor: investor?.items?.map(item => ({ 
      id: item._id,
      name: item.name,
      address: item.address,
      phone: item.phone
    })) || [],
  };
}

export function useProjectCategoriesInvestor() {
  const { data, isLoading, isRefetching, error, refetch } = useQuery({
    queryKey: ["allData"],
    queryFn: fetchAllData,
    refetchOnWindowFocus: false
  });

  return {
    investor: data?.investor || {}, 
    isLoading,
    isRefetching,
    error,
    refetch, 
  };
}
